import { makeRequest } from 'utils/requestLogger';

export default () => makeRequest('post', '/api/users/billing-information');



// WEBPACK FOOTER //
// ./src/app/services/account/getBillingInformation.js